<template>
    <div class="position-relative">
        <a v-show="!cropImg" href="#" @click.prevent="uploadFileClick()" class="btn btn-primary"><uploadicon class="svg-24"></uploadicon> Upload</a>
        <input
            ref="input"
            type="file"
            accept="image/*"
            @change="setImage"
            class="hide-me"
        />

        <div class="position-absolute upload-saving-spinner-wrap">
            <img class="spinner-img" src="/svg/spinner.gif" v-if="update_form_saving">
        </div>

        <a href="#" @click.prevent="deleteFileClick()" v-show="cropImg" class="btn btn-primary pull-right"><trashicon class="svg-24"></trashicon>Delete</a>
        <div class="small-img" @click="crop_or_uploadNewFile()">
            <img :src="cropImg">
        </div>

        <div v-show="networkLogo" @close="networkLogo = false">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-header">
                            <h2 slot="header">Select the area of the image you'd like</h2>
                        </div>
                        <div class="modal-body">
                            <vue-cropper ref="cropper"
                                         :viewMode="2"
                                         :aspect-ratio="1"
                                         :src="imgSrc"
                                         preview=".preview"
                                         :zoomable="false"
                                         :movable="false"
                                         :rotatable="false"
                                         :scalable="false"
                                         :crop="myCropFunction"
                                         :ready="myReadyFunction"
                                         :background="false"
                                         :style="'max-width: 400px; max-height: 400px; margin: 0 auto;'"
                            />
                        </div>
                        <div class="modal-footer">
                            <div class="m-signature-pad--footer">
                                <button type="button" class="btn btn-primary pull-right button save" @click.prevent="cropImage()">Crop and Save Image</button>
                                <button type="button" class="btn btn-default modal-close btn-grey"  @click.prevent="closeModal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal v-if="deleteImageModal" @close="deleteImageModal = false">
            <h3 slot="header">Remove Image</h3>
            <div class="content" slot="body">
                <p>Are you sure you want to remove this image?</p>
            </div>
            <div class="form-group-submit" slot="footer">
                <button class="pull-left" @click.prevent="deleteImageModal = false">Close</button>
                <button class="btn btn-primary pull-right" @click.prevent="deleteFile">Yes, Delete</button>
            </div>
        </modal>

    </div>
</template>

<script>
    import modal from '../components/Modal.vue';
    import uploadicon from '../components/icons/upload.vue';
    import trashicon from '../components/icons/trash.vue';

    export default {
        props: ['initval', 'indexval', 'update_form_saving'],
        components: {modal, trashicon, uploadicon},
        data() {
            return {
                imgSrc: '',
                cropImg: '',
                data: null,
                networkLogo: false,
                lastValidCrop: [],
                file_type: false,
                deleteImageModal: false
            }
        },
        mounted() {
            let that = this;
            if(this.initval) {
                this.cropImg = this.initval;
            }
            that.imgSrc = this.initval;
        },
        methods: {
            uploadFileClick: function() {
                this.$refs.input.value = '';
                this.$refs.input.click()
            },
            deleteFileClick: function() {
                this.deleteImageModal = true;
            },
            deleteFile: function() {
              this.cropImg = '';
              this.$emit('deleteImage', this.cropImg, this.indexval);
            },
            cropImage: function () {

                // get image data for post processing, e.g. upload or setting image src
                this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL(this.file_type);

                var stringLength = this.cropImg.length - 'data:'+this.file_type+';base64,'.length;

                var sizeInBytes = 4 * Math.ceil((stringLength / 3))*0.5624896334383812;
                var sizeInMb=sizeInBytes/1024/1024;

                if(sizeInMb > 10) {
                    alert('The image uploaded is over the 10MB file size limit. Please crop the image smaller, reduce the file size, or try another file.');
                    return;
                }

                this.$emit('croppedImage', this.cropImg, this.indexval);
                this.networkLogo = false;
            },
            myCropFunction: function(e) {

                let app = this;
                let cropper = app.$refs.cropper;

                let minWidth = 600;
                let minHeight = 600;
                //let cData = cropper.getCanvasData();
                // cData contains the details of the actual cropper canvas
                // ie: height: 245, left: 0.25, naturalHeight: 600, naturalWidth: 900, top: 0, width: 367.5
                // the naturals are the actual image dimensions while the height and width are the canvas dimensions

                // cropper.getData() returns x,w,width,height of the current selection
                // the result of that is the format for setData()
                // ie:  cropper.setData({x: 0, y: 0, width: minCropWidth, height: minCropHeight});
                //
                // console.log(cData.naturalWidth);
                // console.log(cData.naturalHeight);
                // console.log(cData);
                // console.log(cropper.getData());

                if(e.detail.width < 600 || e.detail.height < 600) {
                    if (app.lastValidCrop)
                        cropper.setData({x: app.lastValidCrop.x, y: app.lastValidCrop.y, width: minWidth, height: minHeight});
                    else {
                        cropper.setData({x: 0, y: 0, width: minWidth, height: minHeight});
                    }
                    cropper.setData(app.lastValidCrop);
                } else {
                    app.lastValidCrop = cropper.getData();
                }
            },
            myReadyFunction: function(e) {

                let cropper = this.$refs.cropper;
                cropper.setData({x: 0, y: 0, width: 600, height: 600});
            },
            closeModal: function() {
                this.cropImg = '';
                this.$refs.input.value = '';
                location.reload(); // fix a blank box showing up on cancel
            },
            setImage(e) {
                let that = this;
                const file = e.target.files[0];
                if (file.type.indexOf('image/') === -1) {
                    alert('Please select an image file');
                    return;
                }
                this.file_type = file.type;
                if (typeof FileReader === 'function') {
                    const reader = new FileReader();
                    reader.onload = (event) => {

                        // This section confirms the file dimensions are the minimum acceptable.
                        // If acceptable it initialize the cropper for use otherwise it gives them an alert
                        var image = new Image();
                        image.src = event.target.result;
                        image.onload = function () {
                            var height = this.height;
                            var width = this.width;
                            if (height < 600 || width < 600) {
                                alert("Sorry, Minimum dimensions are 600 pixels height and 600 pixels width. Please try another file.");
                                return false;
                            } else if (height == 600 && width == 600) {
                                that.cropImg = event.target.result;
                                that.$emit('croppedImage', that.cropImg, that.indexval);
                            } else {
                                that.cropImg = event.target.result;
                                that.networkLogo = true;
                                // rebuild cropperjs with the updated source
                                that.$refs.cropper.replace(event.target.result);
                            }
                        };
                    };
                    reader.readAsDataURL(file);
                } else {
                    alert('Sorry, FileReader API not supported');
                }
            },
            crop_or_uploadNewFile: function() {
                if(this.cropImg) {
                    this.uploadFileClick();
                } else {
                    this.networkLogo = false;
                }
            }
        }
    }
</script>
